import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import ResourcesImage from 'assets/images/home/hubIcon.svg'
import { Button } from 'components/Button'

import { FrameworkSection } from './sections/FrameworkSection'
import { ListSection } from './sections/ListSection'
import { ProcessSection } from './sections/ProcessSection'
import { QuestionsSection } from './sections/QuestionsSection'
import { Welcome } from './sections/WelcomeSection'

interface HomeLocationState {
  scrollTo?: string
}

export const Home = () => {
  const location = useLocation()

  useEffect(() => {
    const state = location.state as HomeLocationState | null
    if (!state?.scrollTo) return

    const timer = setTimeout(() => {
      document.getElementById(state.scrollTo!)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 0)

    return () => clearTimeout(timer)
  }, [location.state])

  function openResourcePage(): void {
    const link = document.createElement('a')
    link.href =
      'https://playground-stage.coke.com/application/ea2e6e30-c603-42ec-b7e8-a226baa41028/onboarding_0a68026e-907d-146a-8190-917d60120000_onboarding'
    link.click()
  }

  return (
    <div className="container">
      <Welcome />
      <FrameworkSection />
      <ProcessSection />
      <ListSection />
      <QuestionsSection />
      <div className="flex flex-col md:flex-row md:justify-between w-full h-auto md:h-[154px] overflow-hidden border-solid border-2 border-[#f1f1f1] mx-auto my-10 md:my-20 rounded-[16px] bg-[linear-gradient(91.68deg,_#FE560E_24.22%,_#A9997E_40.6%,_#6BC8CD_59.87%,_#6BCAA1_77.75%,_#6BCB83_89.68%)] p-6 md:p-0">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-0">
          <img src={ResourcesImage} alt="Resources Hub Icon" />
          <div className="w-full md:w-[480px] flex flex-col py-0 md:py-[42px] pl-0 sm:pl-12 text-white">
            <p className="font-semibold text-[22px] md:text-[28px] mb-2">BVA Resources Hub</p>
            <p className="font-semibold text-[14px]">Everything you need to develop your BVA Framework</p>
          </div>
        </div>
        <Button
          text="See all resources"
          color="white"
          border={false}
          className="self-start md:self-center mt-4 md:mt-0 md:mr-[38px] py-2.5 px-4"
          onClick={openResourcePage}
        />
      </div>
    </div>
  )
}
